import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@pella/sash-framework';

const APPTCalendarDay = ({ innerText, onClick, selected, id, empty, hasTimeslots, arrayStartPosition, timeslotLength, disabled }) =>
	empty ? (
		<div className='invisible' />
	) : (
		<Button
			className={`!text-subtitle-2 min-h-[37px] w-full rounded-[3px] border-0 p-2 md:min-h-[54px] xl:min-h-[56px] ${!hasTimeslots ? '' : selected ? '!bg-black !text-white' : '!bg-gray-15 !text-black'}`}
			color='secondary'
			type='button'
			disabled={disabled ? true : hasTimeslots ? false : true}
			onClick={() => {
				onClick(id, arrayStartPosition, timeslotLength);
			}}
			aria-label={innerText ? innerText : 'Unavailable Day'}
		>
			{innerText ? innerText : ''}
		</Button>
	);

APPTCalendarDay.propTypes = {
	innerText: PropTypes.number,
	onClick: PropTypes.func.isRequired,
	selected: PropTypes.bool,
	id: PropTypes.any,
	empty: PropTypes.bool,
	hasTimeslots: PropTypes.bool,
	arrayStartPosition: PropTypes.number,
	timeslotLength: PropTypes.number,
	disabled: PropTypes.bool,
};

export default APPTCalendarDay;
